module.exports = require("@swa-ui/core/src/Sticky/Sticky.module.scss");